import { customAlphabet } from "nanoid";

export default function generateShortId(size = 10) {
    const generateNanoId = customAlphabet(
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ",
        size,
    );

    return generateNanoId();
}
